import { 
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE
} from 'react-admin';
import userDataProvider, { userLifecycleCallbacks } from "./user.dataProvider"
import { USER_ROLES } from "../roles/constants";
import { PROVIDER_RESOURCE } from './constants';

export const PROVIDER_RESOURCE_NAME = PROVIDER_RESOURCE;

/**
 * Wraps the user data provider to filter for provider users only
 */
const wrapUserDataProvider = (method, params) => {
    // Add role_name filter for all list/reference operations
    if ([GET_LIST, GET_MANY, GET_MANY_REFERENCE].includes(method)) {
        return {
            ...params,
            filter: {
                ...params?.filter,
                role_name: USER_ROLES.PROVIDER
            }
        };
    }
    
    // For create operations, set the role
    if (method === CREATE) {
        return {
            ...params,
            data: {
                ...params.data,
                role_name: USER_ROLES.PROVIDER
            }
        };
    }
    
    return params;
};

const providerRequestToHttpRequest = (method, params) => {
    const wrappedParams = wrapUserDataProvider(method, params);
    return userDataProvider.providerInterface.providerRequestToHttpRequest(method, wrappedParams);
};

const httpResponseToProviderData = userDataProvider.providerInterface.httpResponseToProviderData

export default {
  resource: PROVIDER_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData
  },
  lifecycleCallbacks: {
    ...userLifecycleCallbacks,
    resource: PROVIDER_RESOURCE_NAME
  }
};